import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  headingContainer: (isVisible = false, small: boolean) => ({
    position: 'absolute',
    height: '40px',
    bottom: small ? 40 : 42,
    right: '0',
    marginLeft: '-40px',
    paddingLeft: '40px',
    display: ['none', 'none', 'none', 'none', 'flex'],
    cursor: 'pointer',
    zIndex: theme.zIndex.documentHigh,
    ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.fast),
    ...(isVisible ? {
      opacity: 1
    } : {
      opacity: small ? 1 : 0
    }),
    '.headingWrapper': {
      mr: '40px',
      ...reusables.mainTransition('transform', theme.transitions.animation.atomCurve, theme.transitions.time.normal),
      transform: `translateX(${small && isVisible ? '0' : '100%'})`,
      h6: {
        textTransform: 'uppercase !important'
      }
    },
    '.headContainer': {
      ml: '16px',
      maxWidth: small ? 134 : 207,
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.normal),
      opacity: isVisible && small ? 1 : 0
    },
    '&:hover': {
      '.headingWrapper': {
        transform: 'translateX(0)'
      },
      '.headContainer': {
        opacity: 1
      }
    },
    '&:focus-visible': {
      position: 'absolute',
      opacity: 1,
      '.headingWrapper': {
        transform: 'translateX(0)'
      },
      '.headContainer': {
        opacity: 1
      }
    }
  }),
  icon: {
    position: 'absolute',
    top: 0,
    left: -40
  }
};